module.exports = __webpack_public_path__ + "static/media/growbeds1.4d19c439.jpg";